import Vue from 'vue'

Vue.component('system-clients-index', require('./views/system/clients/index').default);
Vue.component('system-clients-form', require('./views/system/clients/form').default);
Vue.component('system-users-form', require('./views/system/users/form').default);
Vue.component('system-certificate-index', require('./views/system/certificate/index').default);
Vue.component('system-companies-form', require('./views/system/companies/form').default);
Vue.component('system-accounting-index', require('./views/tenant/account/system/accounting/index').default);
Vue.component('system-plans-index', require('./views/system/plans/index').default);
Vue.component('system-plans-form', require('./views/system/plans/form').default);

Vue.component('system-update', require('./views/system/update/index').default);
Vue.component('system-backup', require('./views/system/backup/index').default);
Vue.component('system-configuration-culqi', require('./views/system/configuration/culqi').default);
Vue.component('system-configuration-apk-url', require('./views/system/configuration/apk-url').default);
Vue.component('system-configuration-token', require('./views/system/configuration/tokenRucDni').default);
Vue.component('system-configuration-token-pse', require('./views/system/configuration/tokenPse').default);
Vue.component('system-php-configuration', require('./views/system/configuration/php_info').default);
Vue.component('system-server-status', require('./views/system/configuration/server_status').default);
Vue.component('system-login-settings', require('./views/system/configuration/login').default);
Vue.component('system-login-other-configuration', require('./views/system/configuration/other_configuration').default);
